import { render, staticRenderFns } from "./AllUsers.vue?vue&type=template&id=0bc4e28e&"
import script from "./AllUsers.vue?vue&type=script&lang=js&"
export * from "./AllUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports